import React from 'react';
import {withTranslation} from 'react-i18next';
import {Row, Col, Table} from 'reactstrap';
import LoaderButton from '../components/LoaderButton';
import {NotificationManager} from '../components/common/react-notifications';
import {i18nizeDate, selectStyles} from '../helpers/Utils';
import Select from 'react-select';
import Api from '../services/Api';
import Rbac from '../components/Rbac';
import {forEach} from 'lodash';
import {application} from "../constants/configs";

class BankAccountDetails extends React.Component {
  constructor(props) {
    super(props);
    this.cardReasonOptions = [
      {label: props.t('Non-acceptance - invalid card'), value: props.t('Non-acceptance - invalid card')},
      {label: props.t('Non-acceptance - the account belongs to another person'), value: props.t('Non-acceptance - the account belongs to another person')},
      {label: props.t('Non-acceptance - inactive card'), value: props.t('Non-acceptance - inactive card')},
      {label: props.t('Non-acceptance - invalid account number'), value: props.t('Non-acceptance - invalid account number')},
    ];
    this.ibanReasonOptions = [
      {label: props.t('Non-acceptance - the account belongs to another person'), value: props.t('Non-acceptance - the account belongs to another person')},
      {label: props.t('Non-acceptance - invalid account number'), value: props.t('Non-acceptance - invalid account number')},
      {label: props.t('Non-acceptance - invalid sheba number'), value: props.t('Non-acceptance - invalid sheba number')},
    ];
    this.statusOptions = [
      {label: props.t('Pending'), value: 'Pending'},
      {label: props.t('Verified'), value: 'Verified'},
      {label: props.t('Rejected'), value: 'Rejected'},
    ];
    this.state = {
      selectedStatus: props.bankAccount ? this.statusOptions.find(item => item.value === props.bankAccount.status) : null,
      selectedReason: props.bankAccount ? [...this.cardReasonOptions, ...this.ibanReasonOptions].find(item => item.value === props.bankAccount.rejectionReason) : null,
      inquiringCardNumber: false,
      inquiringSheba: false,
    };
  }

  cardInquiry = async () => {
    const {t, bankAccount, itemIndex, updateList} = this.props;
    this.setState({
      inquiringCardNumber: true,
    });
    try {
      const {data} = await Api.invoke('GET', `/v2/admin-ui/inquiries/bankCardNumbers/${bankAccount.id}`);
      updateList({cardNumberInquiry: JSON.stringify(data)}, itemIndex);
      NotificationManager.info(this.getCardInquiryResult(data), t('Message'), 20000);
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        inquiringCardNumber: false,
      });
    }
  };

  shebaInquiry = async () => {
    const {t, bankAccount, itemIndex, updateList} = this.props;
    this.setState({
      inquiringSheba: true,
    });
    try {
      const {data} = await Api.invoke('GET', `/v2/admin-ui/inquiries/ibans/${bankAccount.id}`);
      updateList({ibanInquiry: JSON.stringify(data)}, itemIndex);
      NotificationManager.info(this.getShebaInquiryResult(data), t('Message'), 20000);
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        inquiringSheba: false,
      });
    }
  };

  getIbanStatus = status => {
    const {t} = this.props;
    switch (status) {
      case 'ACTIVE':
        return t('Active');
      case 'BLOCK_WITH_DEPOSIT':
        return t('Blocked With Deposit');
      case 'BLOCK_WITHOUT_DEPOSIT':
        return t('Blocked Without Deposit');
      case 'IDLE':
        return t('Idle');
      default:
        return t('Unknown');
    }
  };

  getCardInquiryResult = data => {
    const {t} = this.props;
    return `${t('Bank card belongs to')} [${data.owner}]`;
  };

  getShebaInquiryResult = data => {
    const {t} = this.props;
    const {owners, status} = data;
    let belongsTo = '';
    if (owners && owners.length) {
      let names = '';
      forEach(owners, owner => {
        names += `[${owner.firstName} ${owner.lastName}]`;
      });
      belongsTo = `${t('Iban Belongs to')} ${names} - ${t('Account Status')}: ${this.getIbanStatus(status)}`;
    }
    return `${belongsTo}`;
  };

  getPatchEndpoint = () => {
    if (application.supportV2 && application.platformName === "zarindax") {
      const {bankAccount} = this.props;
      const iban = bankAccount.iban || bankAccount.nationalAccountNumber;
      return iban ?
        '/v2/admin-ui/user-bank-account/iban' :
        '/v2/admin-ui/user-bank-account/card-number';
    }
    return "/admin-ui/user-bank-account";
  };

  onChangeStatus = async selected => {
    this.setState({
      selectedStatus: selected,
    });
    const {t, bankAccount, itemIndex, updateList} = this.props;
    try {
      await Api.invoke(
        'PATCH',
        this.getPatchEndpoint(),
        {
          status: selected.value,
          accountId: bankAccount.id,
        }
      );
      updateList({status: selected.value}, itemIndex);
      NotificationManager.success(t('Status updated successfully'), t('Message'));
    } catch (e) {
      this.setState({
        selectedStatus: this.statusOptions.find(item => item.value === bankAccount.status),
      });
      console.log('error: ', e);
    }
  };

  onChangeReason = async selected => {
    this.setState({
      selectedReason: selected,
    });
    const {t, bankAccount, itemIndex, updateList} = this.props;
    try {
      await Api.invoke(
        'PATCH',
        this.getPatchEndpoint(),
        {
          rejectionReason : selected.value,
          accountId: bankAccount.id,
        }
      );
      updateList({rejectionReason: selected.value}, itemIndex);
      NotificationManager.success(t('Rejection reason submitted successfully'), t('Message'));
    } catch (e) {
      this.setState({
        selectedReason: [...this.cardReasonOptions, ...this.ibanReasonOptions].find(item => item.value === bankAccount.rejectionReason),
      });
      console.log('error: ', e);
    }
  };

  render() {
    const {t, bankAccount} = this.props;
    const iban = bankAccount.iban || bankAccount.nationalAccountNumber;
    return(
      <div className="table-row-sub p-2">
        <Row>
          <Col>
            <span>{t('Inquiry Status')}</span>
            <Select
              className="w-100"
              styles={selectStyles}
              value={this.state.selectedStatus}
              onChange={this.onChangeStatus}
              options={this.statusOptions}
              placeholder={t('Select')}
              isDisabled={!Rbac.hasPermission('update_user-bank-accounts')}
            />
          </Col>
          <Col>
            <span>{t('Rejection Reason')}</span>
            <Select
              className="w-100"
              styles={selectStyles}
              placeholder={t('Select')}
              value={this.state.selectedReason}
              onChange={this.onChangeReason}
              options={iban ? this.ibanReasonOptions : this.cardReasonOptions}
              isDisabled={!Rbac.hasPermission('update_user-bank-accounts')}
            />
          </Col>
        </Row>
        <Table bordered responsive className="my-2">
          <tbody>
          {!!bankAccount.cardNumber &&
            <tr>
              <td className="text-info text-center" style={{width: '150px'}}>
                {t('Card Inquiry')}
              </td>
              <td>
                {bankAccount.cardNumberInquiry ?
                  this.getCardInquiryResult(JSON.parse(bankAccount.cardNumberInquiry)) :
                  t('Inquiry result not found')
                }
              </td>
              <Rbac permission='update_user-kyc'>
                <td style={{width: '100px'}}>
                  <LoaderButton
                    loading={this.state.inquiringCardNumber}
                    disabled={this.state.inquiringCardNumber}
                    onClick={this.cardInquiry}>
                    {t('Inquiry')}
                  </LoaderButton>
                </td>
              </Rbac>
            </tr>
          }
          {!!iban &&
            <tr>
              <td className="text-info text-center" style={{width: '150px'}}>
                <span>{t('Sheba Inquiry')}</span>
              </td>
              <td>{bankAccount.ibanInquiry ?
                this.getShebaInquiryResult(JSON.parse(bankAccount.ibanInquiry)) :
                t('Inquiry result not found')
              }</td>
              <Rbac permission='update_user-kyc'>
                <td style={{width: '100px'}}>
                  <LoaderButton
                    loading={this.state.inquiringSheba}
                    disabled={this.state.inquiringSheba}
                    onClick={this.shebaInquiry}>
                    {t('Inquiry')}
                  </LoaderButton>
                </td>
              </Rbac>
            </tr>
          }
          {!!bankAccount.deletedAt &&
            <tr>
              <td className="text-info text-center" style={{width: '150px', height: "60px"}}>
                <span>{t('Deleted At')}</span>
              </td>
              <td>{i18nizeDate(bankAccount.deletedAt)}</td>
              <td />
            </tr>
          }
          </tbody>
        </Table>
      </div>
    );
  }
}

export default withTranslation()(BankAccountDetails);
